(() => {
  const STORAGE_KEY = 'plp:view';
  const ROOT = document.documentElement;
  const SAFARI_DESKTOP_ATTRIBUTE = 'data-plp-desktop-safari';

  function isDesktopSafari() {
    const userAgent = navigator.userAgent;
    const isSafariBrowser =
      /Safari/i.test(userAgent) &&
      !/Chrome|Chromium|CriOS|Edg|OPR|Firefox|FxiOS|SamsungBrowser/i.test(
        userAgent,
      );
    const isDesktopViewport = window.innerWidth >= 990;
    return isSafariBrowser && isDesktopViewport;
  }

  function syncSafariDesktopState() {
    if (isDesktopSafari()) {
      ROOT.setAttribute(SAFARI_DESKTOP_ATTRIBUTE, 'true');
      return;
    }
    ROOT.removeAttribute(SAFARI_DESKTOP_ATTRIBUTE);
  }

  function refreshSafariDesktopGrid() {
    if (!ROOT.hasAttribute(SAFARI_DESKTOP_ATTRIBUTE)) return;
    const productGrid = document.getElementById('product-grid');
    if (!productGrid) return;
    productGrid.style.setProperty('display', 'none');
    productGrid.offsetHeight;
    productGrid.style.removeProperty('display');
    window.requestAnimationFrame(() => {
      productGrid.offsetHeight;
    });
  }

  function setView(view) {
    const v = view === 'image' ? 'image' : 'default';
    ROOT.setAttribute('data-plp-view', v);

    // Update active icon state
    document
      .querySelectorAll('.collection-toolbar__view-button')
      .forEach((btn) => {
        const isActive = btn.dataset.plpView === v;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

    try {
      localStorage.setItem(STORAGE_KEY, v);
    } catch (e) {}

    refreshSafariDesktopGrid();
  }

  function syncStoqBadges(scope) {
    const badges = scope.querySelectorAll(
      '.preorder-badge-collection:not([data-plp-stoq-synced])',
    );

    badges.forEach((badge) => {
      const card = badge.closest('.card-wrapper, .card, .grid__item');
      if (!card) return;

      const bucket =
        card.querySelector('.card__badge.badge--bottom-left') ||
        card.querySelector('.card__badge') ||
        card.querySelector('.card__content');

      if (!bucket) return;

      badge.dataset.plpStoqSynced = 'true';
      badge.classList.add('plp-stoq-badge');
      bucket.appendChild(badge);

      // If STOQ Preorder badge is present, suppress "Sold out" to avoid conflicting states
      const soldOut = bucket.querySelector('.badge--sold-out');
      if (soldOut) {
        soldOut.hidden = true;
      }
    });
  }

  function initStoqBadgeFix() {
    const grid = document.getElementById('product-grid');
    if (!grid) return;

    const run = () => syncStoqBadges(grid);

    // Run immediately + when STOQ finishes loading
    run();
    window.addEventListener('stoq:loaded', run);

    // Catch badges/cards added later (load more, app reinject, etc.)
    let raf = 0;
    const schedule = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = 0;
        run();
      });
    };

    new MutationObserver(schedule).observe(grid, {
      childList: true,
      subtree: true,
    });
  }

  function init() {
    syncSafariDesktopState();

    // Load saved view (if any)
    let saved = 'default';
    try {
      saved = localStorage.getItem(STORAGE_KEY) || 'default';
    } catch (e) {}

    setView(saved);

    document.addEventListener('click', (e) => {
      const btn = e.target.closest(
        '.collection-toolbar__view-button[data-plp-view]',
      );
      if (!btn) return;
      e.preventDefault();
      setView(btn.dataset.plpView);
    });

    window.addEventListener('resize', syncSafariDesktopState, { passive: true });
  }

  initStoqBadgeFix();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();